import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const LEGACY_FORM_DIALOG_CLASS_NAME = 'LegacyFormDialog';
export const LEGACY_FORM_DIALOG_CLASS_SLOTS = [
	'root',
	'actions',
	'cancelButton',
	'content',
	'form',
	'progress',
	'submit',
] as const;

export type LegacyFormDialogClassSlot =
	(typeof LEGACY_FORM_DIALOG_CLASS_SLOTS)[number];

export interface LegacyFormDialogClasses {
	root: string;
	actions: string;
	cancelButton: string;
	content: string;
	form: string;
	progress: string;
	submitButton: string;
}

export type LegacyFormDialogClassKey = keyof LegacyFormDialogClasses;

export const getLegacyFormDialogUtilityClass = (slot: string) =>
	generateUtilityClass(LEGACY_FORM_DIALOG_CLASS_NAME, slot);

export const legacyFormDialogClasses: LegacyFormDialogClasses =
	generateUtilityClasses(LEGACY_FORM_DIALOG_CLASS_NAME, [
		'root',
		'actions',
		'cancelButton',
		'content',
		'form',
		'progress',
		'submitButton',
	]);

export default legacyFormDialogClasses;
